import React, { useState }  from "react";
import { Row, Col, Button,Checkbox ,Table ,Form} from "antd";
import { RightOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
const Customstyle = styled.div`
  .head {
    display: flex;
    align-item: center;
    justify-content: space-between;
    color: #1B1B1B;
    font-weight: bold;
  }
     .ant-table-tbody > tr > td {
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.5;
    color: #000000;
    }`;

function Proposal() {
    const [form] = Form.useForm();
  const [filteredData, setFilteredData] = useState([]);
  const dataSource = [
    {
      key: '1',
      Proposal_name: 'BDO Internal Audit - Technical Proposal.pdf',
      Created_on: '01 Jul 2022',
      Created_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Proposal_name: 'Technical audit proposal',
        Created_on: '01 Jul 2022',
        Created_By: 'Willow Lee',
      },
      {
        key: '3',
        Proposal_name: 'Tax proposal',
        Created_on: '01 Jul 2022',
        Created_By: 'Harper Martin',
      },
];
const [loading, setLoading] = useState(false);
const navigate = useNavigate(); 
const handleCreateNew = () => {
  navigate("/CreateNew"); 
};
  const columns = [
    {
        title: 'Proposal name',
        dataIndex: 'Proposal_name',
        key: 'Proposal_name',
        width: 750,
        ellipsis: false, // Disable truncation
        render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
       
      },
      {
        title: 'Created on',
        dataIndex: 'Created_on',
        key: 'Created_on',
        width: 500,
        ellipsis: false, // Disable truncation
        render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
       
      },
      {
        title: 'Created By',
        dataIndex: 'Created_By',
        key: 'Created_By',
        width: 500,
        ellipsis: false, // Disable truncation
        render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
       
      },
  ]
  return (
    <>
      <Customstyle>
      <Row gutter={16}>
        <Col xl={24} sm={24} xs={24}>
          <div className="head">
            <div>
              <span>Company Document </span>
              <RightOutlined className="Right_outlined" />
              <span> Proposal</span>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button type="primary"
              style={{ backgroundColor: "#C2FAE5",color:"#000000"}}
              onClick={handleCreateNew}
              >Create New Proposal</Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row gutter={12} className="g-3 mb-2">
  <Col xs={24} sm={24} md={12} lg={8} xl={4}>
    <Checkbox.Group>
      <label>Search</label>
      {/* Options can be added here later if needed */}
    </Checkbox.Group>
  </Col>
  </Row>
  <Table
               dataSource={dataSource}
                columns={columns}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table"
              />
      </Customstyle>
    </>
  );
}

export default Proposal;
